<template>
  <v-footer absolute class="font-weight-medium footer-frame">
    <v-container>
      <v-row class="justify-center">
        <v-col cols="6" sm="3" md="2" class="pl-0 pl-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">Layanan Pelanggan</div>
          <div class="text-caption" v-if="content['Layanan Pelanggan']">
            <router-link
              :to="'/page/' + data.content_slug"
              v-for="data in content['Layanan Pelanggan']"
              :key="data.content_id"
              class="text-deco black--text"
            >
              <div class="pt-1 text-capitalize">{{data.content_title}}</div>
            </router-link>
          </div>
          <div class="text-caption" v-else></div>
        </v-col>
        <v-col cols="6" sm="3" md="2" class="pr-0 pr-md-3" v-show="false">
          <div class="text-uppercase text-caption font-weight-bold pb-2">Perusahaan</div>
          <div class="text-caption" v-if="content['Lainnya']">
            <router-link
              :to="'/page/' + data.content_slug"
              v-for="data in content['Lainnya']"
              :key="data.content_id"
              class="text-deco black--text"
            >
              <div class="pt-1 text-capitalize">{{data.content_title}}</div>
            </router-link>
          </div>
          <div class="text-caption" v-else></div>
        </v-col>
        <v-col cols="6" sm="3" md="3" class="pl-0 pl-md-3">
          <div class="text-uppercase text-caption font-weight-bold pb-2">Pembayaran</div>
          <div>
            <v-col class="py-0">
              <v-row>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/bca.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/bni.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/mandiri.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/bri.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/btn.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/danamon.svg"></v-img>
                </v-col>
                <v-col cols="6" class="pl-0 pr-1 pt-0 pb-1">
                  <v-img eager src="/assets/bank/permata-bank.svg"></v-img>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-col>
        <v-col cols="6" sm="3" md="3" class="pr-0 pr-md-3" v-if="pengirimanArr.length > 0">
          <div class="text-uppercase text-caption font-weight-bold pb-2">Pengiriman</div>
          <div>
            <v-col class="py-0">
              <v-row>
                <v-col v-for="(item) in pengirimanArr" :key="item" cols="4" class="pl-0 pl-md-3" style="display: flex; flex-direction: column; justify-content: center;">
                  <v-img eager  max-height="60" contain class="my-auto" :src="`/assets/courier/${item}.svg`"></v-img>
                </v-col>
                <!-- <v-col cols="4" v-show="chechCourier('jnt')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/j&t.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('jtcargo')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/jtcargo.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('sicepat')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/sicepat.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('anteraja')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/anteraja.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('grab_express')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/grab_express.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('gosend')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/gosend.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('tiki')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/tiki.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('ninja')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/ninja.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('pos')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pos.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('jet')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/jet.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('lion')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/lion.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('wahana')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/wahana.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('pahala')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pahala.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('dse')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/dse.svg"></v-img>
                </v-col>
                <v-col cols="4" v-show="chechCourier('pandu')" class="pl-0 pl-md-3">
                  <v-img eager src="/assets/courier/pandu.svg"></v-img>
                </v-col> -->
              </v-row>
            </v-col>
          </div>
        </v-col>
        <v-col cols="4" sm="3" md="2" class="pl-0 pl-md-3">
          <!-- <div class="text-uppercase text-caption font-weight-bold pb-2">Ikuti Kami</div> -->
          <div class="text-caption">
            <!-- <div class="d-flex">
              <div>
                <img width="20" src="/assets/sosmed/facebook.svg" />
              </div>
              <div class="pl-2">Facebook</div>
            </div>
            <div class="d-flex pt-1">
              <div>
                <img width="20" src="/assets/sosmed/twitter.svg" />
              </div>
              <div class="pl-2">Twitter</div>
            </div>-->
            <template v-if="true">
              <!-- <div class="d-flex pt-1">
                <div>
                  <a href="https://www.instagram.com/" target="_blank">
                    <img width="20" src="/assets/sosmed/instagram.png" />
                  </a>
                </div>
                <div
                  class="pl-2"
                  style="cursor: pointer; "
                  onclick="window.open('https://www.instagram.com/')"
                >Instagram</div>
              </div>
              <div class="d-flex pt-1">
                <div>
                  <a href="https://www.tiktok.com/" target="_blank">
                    <img width="20" src="/assets/sosmed/tiktok.png" />
                  </a>
                </div>
                <div
                  class="pl-2"
                  style="cursor: pointer; "
                  onclick="window.open('https://www.tiktok.com/')"
                >Tiktok</div>
              </div> -->

              <div class="d-flex pt-1">
                <div>
                  <a
                    href="https://play.google.com/store/apps/details?id=banni.book"
                    target="_blank"
                  >
                    <img width="150" src="/assets/icons/googleplay.png" />
                  </a>
                </div>
              </div>
            </template>
            <!-- <div class="d-flex pt-1">
              <div>
                <img width="20" src="/assets/sosmed/line.svg" />
              </div>
              <div class="pl-2">WhatsApp</div>
            </div>-->
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-2 pb-0 px-0 pt-md-0 px-md-3">
          <v-divider></v-divider>
          <div
            class="pt-4 pb-1 text-caption"
          >&copy; {{ new Date().getFullYear() }}. Hak Cipta Dilindungi</div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("content", ["content"])
  },
  data(){
    return{
      store:process.env.VUE_APP_STORE_SLUG,
      pengirimanArr:[
        "anteraja",
        "gosend",
        "grab_express",
        "idx",
        "jtcargo",
        "jnt",
        "jne",
        "sicepat",
        "kriminaja",
      ]
    }
  },
  methods: {
    ...mapActions("store", ["getStoreDetail"]),
    ...mapActions("content", ["getContent"]),
    // getStoreShipment(){
    //   if(!process.env.VUE_APP_STORE_SLUG) return
    //   this.getStoreDetail({
    //   slug: this.store
    //     }).then(res => {
    //       const {store_courier} =res
    //       this.pengirimanArr = JSON.parse(store_courier)
    //     })
    // },
    // chechCourier(param){
    //   if(this.pengirimanArr.length < 1 ) return false
    //   return this.pengirimanArr.includes(param)
    // }
  },
  mounted(){
    // this.getStoreShipment()
  },
  created() {
    this.getContent();
  },
};
</script>
